import type { GanttExtensionRegistries } from '../gantt-view-manager.js';
import { DependencyAcyclicConstraint } from './dependency-acyclic-constraint.js';
import { GanttSnappingSettingsSection } from './gantt-snapping-settings.js';
import { IdentityPositionTransform } from './identity-position-transform.js';
import { SnapToGridConstraint } from './snap-to-grid-constraint.js';
import { StartBeforeEndConstraint } from './start-before-end-constraint.js';

export { DependencyAcyclicConstraint } from './dependency-acyclic-constraint.js';
export { GanttSnappingSettingsSection } from './gantt-snapping-settings.js';
export { IdentityPositionTransform } from './identity-position-transform.js';
export { SnapToGridConstraint } from './snap-to-grid-constraint.js';
export { StartBeforeEndConstraint } from './start-before-end-constraint.js';

/**
 * Registers the constraints / decorators / transforms / settings sections
 * that ship with the core Gantt view.
 *
 * Called from {@link GanttSingleView}'s constructor — third-party
 * extensions register against the same registries via
 * `view.extensions.<registry>.register(...)`.
 */
export function registerDefaultExtensions(
  extensions: GanttExtensionRegistries
): void {
  extensions.positionTransforms.register(new IdentityPositionTransform());
  extensions.dragConstraints.register(new StartBeforeEndConstraint());
  extensions.dragConstraints.register(new SnapToGridConstraint());
  extensions.dragConstraints.register(new DependencyAcyclicConstraint());
  extensions.settingsSections.register(new GanttSnappingSettingsSection());
}
